import React from "react";
import LocationPage from "./LocationPage";

export default function WebdesignAgenturKaernten() {
  return <LocationPage locationKey="kaernten" />;
}
